import { Box, Typography } from "@mui/material";
import { toToman } from "../../utils/Utils";
import {  useState } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function BoxInfoCollapse({ sx = [], ...props }) {
  const { result } = props;
  const [infoAccordianShow, setInfoAccordianShow] = useState(false);

  return (
    <Box
      mt={2}
      sx={{
        py: "10px",
        px: "12px",
        bgcolor: "grey.7",
        borderRadius: "10px",
        overflow: "hidden"
      }}>

      <Box
        onClick={() => setInfoAccordianShow((prev) => !prev)}
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="h5"
          sx={{ flexShrink: 0, fontSize: "12px", color: "grey.3" }}
        >
          از ابتدا
        </Typography>

        <Box sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}>


          <Typography
            variant="h5"
            sx={{ flexShrink: 0, color: "grey.3" }}
            mr={1}
          >
            {result && toToman(result?.doneOrders.totalAmount)} تومان
          </Typography>
          <Box sx={{
            transform: infoAccordianShow ? "rotate(-180deg);" : "rotate(0deg);",
            transition: "all 0.3s ease",
            height: "24px"
          }}>
            <KeyboardArrowUpIcon sx={{ color: "primary.main", height: 20 }} />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          transition: "all 0.3s ease",
          maxHeight: infoAccordianShow ? '100px' : '0px',
          paddingRight: "30px"
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            flexGrow: "1",
            width: "100%",
          }}
        >
          <Typography mt={1} variant="subtitle1" color="grey.3">
            خرید
          </Typography>
          <Typography mt={1} variant="body2" color="grey.3">
            {result && toToman(result?.doneOrders.buyAmount)} تومان
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            flexGrow: "1",
            width: "100%",
          }}
        >
          <Typography mt={1} variant="subtitle1" color="grey.3">
            فروش
          </Typography>
          <Typography mt={1} variant="body2" color="grey.3">
            {result && toToman(result?.doneOrders.sellAmount)} تومان
          </Typography>
        </Box>
      </Box>
    </Box>



  );
}

export default BoxInfoCollapse;
